// P2b tanda 1 — cliente del borrador local. TODO va a /api/product-drafts.
// GARANTÍA de la tanda: ninguna de estas funciones habla con WooCommerce; el
// borrador es 100% Neto/Mongo. Escribir en WooCommerce llega en la tanda 2.

import { formToDraftBody } from './productDraft';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const BASE = `${API_URL}/api/product-drafts`;

export async function listDrafts({ wcProductId } = {}) {
  const qs = wcProductId != null ? `?wcProductId=${encodeURIComponent(wcProductId)}` : '';
  const res = await fetch(`${BASE}${qs}`);
  if (!res.ok) throw new Error('No se pudieron cargar los borradores');
  return res.json();
}

// Crea (POST) si no hay draftId; actualiza (PUT) si lo hay. Devuelve el doc.
export async function saveDraft(form, { draftId = null, wcProductId = null } = {}) {
  const body = formToDraftBody(form, wcProductId);
  const url = draftId ? `${BASE}/${draftId}` : BASE;
  const res = await fetch(url, {
    method: draftId ? 'PUT' : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error('No se pudo guardar el borrador');
  return res.json();
}

export async function deleteDraft(draftId) {
  const res = await fetch(`${BASE}/${draftId}`, { method: 'DELETE' });
  if (!res.ok) throw new Error('No se pudo borrar el borrador');
  return res.json().catch(() => ({}));
}
